module.exports = __webpack_public_path__ + "img/horizontal_4_2_8023.b99c3d50.png";